import { useNotification } from '@/hooks/use-notification';
import { Label } from '@lego/connect-components-react';
import type { MultiValue } from 'chakra-react-select';
import { useState } from 'react';
import Combobox, {
  type ComboboxSize,
  type DefaultOptionType,
} from './combobox';
import { useFilteredPriceUnits } from './combobox-queries';

type PriceUnitsComboboxProps = {
  selectedItems: DefaultOptionType[];
  onSelect: (items: MultiValue<DefaultOptionType>) => void;
  matrixOnly?: boolean;
  countryOnly?: boolean;
  size?: ComboboxSize;
  title?: string;
  isSingleSelect?: boolean;
  isDisabled?: boolean;
  hasError?: boolean;
};

const PriceUnitsCombobox = ({
  selectedItems,
  onSelect,
  matrixOnly = false,
  countryOnly,
  size = 'medium',
  title = 'Planning price lists',
  isSingleSelect = false,
  isDisabled = false,
  hasError = false,
}: PriceUnitsComboboxProps) => {
  const showNotification = useNotification();
  const [searchValue, setSearchValue] = useState('');
  const { data, isFetching } = useFilteredPriceUnits(
    searchValue,
    undefined,
    matrixOnly,
    countryOnly,
  );
  return (
    <div>
      <Label>{title}</Label>
      <Combobox
        options={
          data?.map((item) => ({
            id: item.id.toString(),
            label: `${item.id} - ${item.name ?? 'N/A'}`,
          })) || []
        }
        selectedItems={selectedItems}
        isLoading={isFetching}
        onSelect={(selected: MultiValue<DefaultOptionType>) => {
          const items = [...selected] as DefaultOptionType[];
          const previousItem = selectedItems[0];
          const newItem = items[0];
          if (
            isSingleSelect &&
            newItem !== undefined &&
            previousItem !== undefined &&
            newItem.id !== previousItem.id
          ) {
            showNotification({
              type: 'info',
              title: 'Selected price list changed',
              description: `Selected price list has been changed from "${previousItem.label}" to "${newItem.label}"`,
            });
          }
          onSelect(items);
        }}
        inputValue={searchValue}
        onInputChange={(value: string) => setSearchValue(value)}
        placeholder="Type number or description"
        size={size}
        isSingleSelect={isSingleSelect}
        isDisabled={isDisabled}
        hasError={hasError}
      />
    </div>
  );
};
export default PriceUnitsCombobox;
